import { Component, OnInit } from '@angular/core';
import { NgbDatepickerConfig, NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { VproService } from './../../service/vpro/vpro.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EditPatPresc } from 'src/app/models/epresc';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { Utils } from 'src/app/common/utils';

@Component({
  selector: 'app-editpresc',
  templateUrl: './editpresc.component.html',
  styleUrls: ['./editpresc.component.css']
})
export class EditprescComponent implements OnInit {
  isActive: true
  arrayValueExp = [{
    key: '', value: ''
  }];


  epresc = new EditPatPresc();
  submitted = false;
  model: any;
  model2: any;
  model3: any;
  data: any;
  datar: any;
  pid: any;
  d_id: any;
  aid: any;
  data1: any;
  message: any;
  apdate: any;
  aptime: any;
  minDate = Utils.maxDate;
  patientpr = [];

  closeResult: string;

  constructor(private location: Location, config: NgbDatepickerConfig, calendar: NgbCalendar, private route: ActivatedRoute, private service: VproService, private router: Router) {
    // const currentDate = new Date();

    // config.minDate = {year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate()};
    // config.maxDate = {year: 2099, month: 12, day: 31};

    // config.outsideDays = 'hidden';
    // config.markDisabled = (date: NgbDate) => calendar.getWeekday(date) >= 7;
  }

  ngOnInit() {
    this.aid = this.route.snapshot.params['aid'];
  }

  async Save(data4) {
    try {
      let pdate = data4['sdate']['year'] + "-" + data4['sdate']['month'] + "-" + data4['sdate']['day'];
      let pend = data4['edate']['year'] + "-" + data4['edate']['month'] + "-" + data4['edate']['day'];
      let datar2 = {
        mname: data4['mname'],
        strength: data4['strength'],
        intakefreq: data4['intakefreq'],
        sdate: pdate,
        edate: pend,
        // prid: data4['model']['prid']

      };
      this.submitted = true;

      this.service.updatePresc(this.aid, datar2)
        .subscribe(() => {
        }, err => {
          console.log(err)
        });
    } catch (excep) {
      console.log(excep)
    }

    await Swal.fire({
      allowOutsideClick: false,
      position: 'top',
      type: 'success',
      title: 'Prescription Updated ! ',
      showConfirmButton: false,
      timer: 1500
    });
    this.refresh()
  }

  refresh(): void {
    window.location.reload();
  }

  cancel() {
    //this.router.navigate(['/phydash/pid']);
    this.location.back();

  }
  disableCB() {
    document.getElementById("myCheck").hidden = true;
  }

  enableCB() {
    document.getElementById("myCheck").hidden = false;
  }

  checkBox = [
    { label: 'is it a Session based ?', id: 'mycheck', name: 'sb', checked: false },
    { label: 'is it a Hourly based ? ', id: 'mycheck', name: 'hb', checked: false },

  ];

  checkSelected(label: string) {
    this.checkBox.forEach(x => {
      if (x.label !== label) {
        x.checked = !x.checked
      }
    })
  }
}
